type RaksulGAPayload = {
  category: string
  action: string
  label?: string
}

type RaksulBQPayload = {
  eventName: string
  data: any
}

export const gaEventTracker = (payload: RaksulGAPayload) => {
  // @ts-ignore
  dataLayer.push({event: 'GAEvent', event_category: payload.category, event_action: payload.action, event_label: payload.label})
}
const raksulAnalyticSendEvent = (payload: RaksulBQPayload) => {
  // @ts-ignore
  window.raksulDataCollector.sendEvent(payload.eventName, payload.data)
}
const MAX_RETRY_TIME_RAKSUL_TRACKING = 5
export const raksulBQEventTracker = (payload: RaksulBQPayload) => {
  try {
    const events: RaksulBQPayload[] = []
    let retry = 0
    const sendEventInterval = () => {
      const eventInterval = setInterval(() => {
        // @ts-ignore
        if (window.raksulDataCollector) {
          while (events.length) {
            const item = events.pop()
            if (item) raksulAnalyticSendEvent(item)
          }
          clearInterval(eventInterval)
        }
        retry++
        if (retry === MAX_RETRY_TIME_RAKSUL_TRACKING) clearInterval(eventInterval)
      }, 1000)
    }
    // @ts-ignore
    if (window.raksulDataCollector) {
      raksulAnalyticSendEvent(payload)
    } else {
      events.push(payload)
      sendEventInterval()
    }
  } catch (error) {
    throw new Error('raksulBQEventTracker: ' + error)
  }

}

export const EVENT_CATEGORIES = {
  PRODUCT_DETAIL: 'product_detail',
  EDITOR: 'editor',
  CART: 'cart',
  ORDER_COMPLETE: 'order_complete',
  ORDER_HISTORY: 'order_history'
}

export const EVENT_ACTIONS = {
  CLOSE: 'close',
  COMPLETE: 'complete',
  GUIDE: 'guide',
  LINK_COPY: 'link_copy',
  NEXT: 'next',
  OPEN: 'open',
  OPEN_DIALOG: 'open_dialog',
  SKIP: 'skip',
  SHARE_EMAIL: 'share_email',
  SHARE_FACEBOOK: 'share_facebook',
  SHARE_LINE: 'share_line',
  SHARE_TWITTER: 'share_twitter',
  PROCEED: 'proceed',
  DELETE: 'delete',
  CLICK: 'click',
  DECIDE: 'decide',
  SUBMIT: 'submit'
}

export const EVENT_LABELS = {
  SHARE_IN_IMAGE: 'share_in_image',
  SHARE_DIALOG: 'share_dialog',
  SHARE_IN_DIALOG: 'share_in_dialog',
  SHARE_IN_EDIT_DISPLAY: 'share_in_editDisplay',
  ONBOARDING_START_DIALOG: 'onboarding_start_dialog',
  LOGO_TEXT_ADD_CENTER: 'logo_text_add_center',
  LOGO_TEXT_ADD_LEFT_TOP: 'logo_text_add_leftTop',
  COLOR_PATTERN_CHANGE: 'color_pattern_change',
  EDIT_PATTERN_CHANGE: 'edit_pattern_change',
  TEXT_CHANGE: 'text_change',
  DESIGN_PREVIEW_OPEN: 'design_preview_open',
  DESIGN_PC_SHARE: 'design_pc_share',
  PC_SECOND_COLUMN_UPPER: 'pc_second_column_upper',
  PC_SECOND_COLUMN_LOWER: 'pc_second_column_lower',
  MOBILE_SECOND_COLUMN_UPPER: 'mobile_second_column_upper',
  MOBILE_SECOND_COLUMN_LOWER: 'mobile_second_column_lower',
  PC_THREE_COLUMN_UPPER: 'pc_three_column_upper',
  PC_THREE_COLUMN_LOWER: 'pc_three_column_lower',
  MOBILE_THREE_COLUMN_UPPER: 'mobile_three_column_upper',
  MOBILE_THREE_COLUMN_LOWER: 'mobile_three_column_lower',
  PC_CART_ITEM: 'pc_cart_item',
  MOBILE_CART_ITEM: 'mobile_cart_item',
  PC_3D_MODEL: 'pc_3d_model',
  MOBILE_3D_MODEL: 'mobile_3d_model',
  PC_DELIVERY_DATECHECK_DIALOG: 'pc_delivery_datecheck_dialog',
  PC_ZIP_CHECK: 'pc_zip_check',
  PC_ADDRESS_CHECK: 'pc_address_check',
  MOBILE_DELIVERY_DATECHECK_DIALOG: 'mobile_delivery_datecheck_dialog',
  MOBILE_ZIP_CHECK: 'mobile_zip_check',
  MOBILE_ADDRESS_CHECK: 'mobile_address_check',
  SUBMIT_QUESTIONNAIRE:'submit_questionnaire'
}

export const BQ_EVENT_NAMES = {
  SEARCH_KEYWORD: 'searchKeyword',
  SEARCH_RESULT_CLICK: 'clickSearchResult',
  CLICK_KEYWORD_SEARCH_SUGGESTION: 'clickKeywordSearchSuggestion',
  CLICK_MERCHANDISE: 'stockroom_clickMerchandise',
  VIEW_MERCHANDISE: 'stockroom_displayMerchandise',
  CLICK_PRODUCT_CATEGORY: 'stockroom_clickMerchandiseCategoryPage',
  VIEW_PRODUCT_CATEGORY: 'stockroom_displayMerchandiseCategoryPage',
  CLICK_AWS_PERSONALIZE: 'stockroom_clickAwsPersonalize',
  VIEW_AWS_PERSONALIZE: 'stockroom_displayAwsPersonalize',
  DISPLAY_NEW_CMS_CATEGORY: 'stockroom_displayNewCMSCategory'
}

export const BQ_QUERY_NAMES = {
  SEARCH_TRACK_QUERY: 'trackingSearch',
  ClICK_SUGGESTION_QUERY: 'clickSuggest',
  TRACK_SOURCE_SECTION_QUERY: 'trackSourceSection',
  TRACK_SOURCE_SECTION_ROW_NUMBER: 'trackSourceSectionRowNumber'
}

export const BQ_AWS_PERSONALIZE_PAGE_TYPE = {
  PRODUCT_DETAIL: 'productDetail',
  TOP_PAGE: 'topPage',
  CART_PAGE: 'cartPage',
  FAVORITE_PAGE: 'favoritePage',
  ORDER_HISTORY: 'orderHistory',
  THANKS_PAGE: 'thanks'
}

export const BQ_AWS_PERSONALIZE_LOGIC_TYPE = {
  RECOMMENDED_FOR_YOU: 'recommendedForYou',
  RELATED_PRODUCTS: 'customersWhoViewedXAlsoViewed'
}

export const BQ_AWS_PERSONALIZE_AREA_NAME = {
  RIGHT_SIDE: 'rightSide',
  ABOVE_FOOTER: 'aboveFooter',
  SURVEY: 'survey',
  TOP_SIDE: 'topSide'
}
